import { Add, PhoneAndroid } from "@mui/icons-material";
import { Box, Button, Container, Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, LayoutContext, hasRole } from "wcz-layout";
import { AdvancedSearch } from "../components/homepage/AdvancedSearch";
import { CreateAppDialog } from "../components/app/CreateAppDialog";
import AuthPolicy from "../utils/AuthPolicy";

const NEW_APPSTORE_URL = "https://appstore.wcz-sat-prd-01.k8s.wistron.com/";
const DEVICE_INFO_APP_PATH = "/apps/872cba51-49d3-4023-867e-e6dff201f425";

export const HomePage: React.FC = () => {
    const { changeTitle, t } = useContext(LayoutContext);
    const [newAppOpen, setNewAppOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(true);

    useEffect(() => changeTitle("App Store"), []);

    const toggleNewDocument = useCallback(() => setNewAppOpen(!newAppOpen), [newAppOpen]);

    return (
        <Container maxWidth="xl" sx={{ my: 2 }}>
            <Grid container spacing={1}>
                {hasRole(AuthPolicy.Contributor) &&
                    <Grid item xs={12} sx={{ textAlign: "right", mb: 1 }}>
                        <Button variant="contained" startIcon={<Add />} onClick={toggleNewDocument}>{t("NewApplication")}</Button>
                    </Grid>
                }

                <Grid item xs={12}>
                    <AdvancedSearch />
                </Grid>
            </Grid>

            <CreateAppDialog open={newAppOpen} setOpen={setNewAppOpen} />
            <NewAppDialog open={open} setOpen={setOpen} />
        </Container>
    );
};

interface CreateAppDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
}

const NewAppDialog: React.FC<CreateAppDialogProps> = ({ open, setOpen }) => {
    const { t } = useContext(LayoutContext);
    const navigate = useNavigate();

    const redirectToNewAppStore = useCallback(() => {
        globalThis.location.href = NEW_APPSTORE_URL;
    }, []);

    const goToDeviceInfo = useCallback(() => {
        setOpen(false);
        navigate(DEVICE_INFO_APP_PATH);
    }, [navigate, setOpen]);

    return (
        <Dialog open={open} onClose={() => setOpen(false)} title="App Store Notice" color="primary" disableAutoClose actions={[
            <Button key="submit" variant="contained" onClick={redirectToNewAppStore}>{t("OpenNewAppStore")}</Button>
        ]}>
            <Box sx={{ display: "grid", gap: 2, py: 1 }}>
                <Paper
                    elevation={0}
                    onClick={goToDeviceInfo}
                    sx={{ p: 2, bgcolor: "primary.main", color: "primary.contrastText", borderRadius: 2, display: "flex", alignItems: "center", gap: 2, cursor: "pointer", "&:hover": { bgcolor: "primary.dark" }, transition: "background-color 0.2s" }}
                >
                    <PhoneAndroid sx={{ fontSize: 40 }} />
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="subtitle1" fontWeight="bold">{t("DeviceInfoNotice")}</Typography>
                    </Box>
                </Paper>

                <Divider />

                <Typography variant="body2" color="text.secondary">
                    {t("AppStoreNoticeDeprecated")}
                </Typography>
            </Box>
        </Dialog>
    );
};
